function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  id: "mingcute:book-line",
  clipPath: "url(#clip0_12370_14124)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.3337 4C14.223 4 15.111 4.33733 16.0003 5.01333C16.8897 4.33733 17.7777 4 18.667 4H26.667C27.3742 4 28.0525 4.28095 28.5526 4.78105C29.0527 5.28115 29.3337 5.95942 29.3337 6.66667V24C29.3337 24.7072 29.0527 25.3855 28.5526 25.8856C28.0525 26.3857 27.3742 26.6667 26.667 26.6667H17.3337C17.3337 27.4027 16.7337 28 16.0003 28C15.267 28 14.667 27.4 14.667 26.6667H5.33366C4.62641 26.6667 3.94814 26.3857 3.44804 25.8856C2.94794 25.3855 2.66699 24.7072 2.66699 24V6.66667C2.66699 5.95942 2.94794 5.28115 3.44804 4.78105C3.94814 4.28095 4.62641 4 5.33366 4H13.3337ZM13.3337 6.66667H5.33366V24H14.667V8C14.667 7.26667 14.067 6.66667 13.3337 6.66667ZM26.667 6.66667H18.667C17.9337 6.66667 17.3337 7.26667 17.3337 8V24H26.667V6.66667Z",
  fill: "#D5D8DF"
})));
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_12370_14124"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "white"
})));
const SvgBookLine = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBookLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/book-line.ad27069d.svg";
export { ForwardRef as ReactComponent };